import React from 'react';

export const BANDS = [
  { max: 20, label: 'Insuficiente', bar: 'bg-red-400', text: 'text-red-700', chip: 'bg-red-100 text-red-700' },
  { max: 40, label: 'Em desenvolvimento', bar: 'bg-orange-400', text: 'text-orange-700', chip: 'bg-orange-100 text-orange-700' },
  { max: 60, label: 'Adequado', bar: 'bg-yellow-400', text: 'text-yellow-700', chip: 'bg-yellow-100 text-yellow-800' },
  { max: 80, label: 'Bom', bar: 'bg-lime-500', text: 'text-lime-700', chip: 'bg-lime-100 text-lime-800' },
  { max: 100, label: 'Excelente', bar: 'bg-emerald-500', text: 'text-emerald-700', chip: 'bg-emerald-100 text-emerald-700' },
];

export const bandOf = (nota) => (nota === null || nota === undefined ? null : BANDS.find((b) => nota <= b.max));

export const CompetencyRuler = ({ nota, meta, testId }) => (
  <div className="relative pt-1 pb-4" data-testid={testId}>
    <div className="flex h-2.5 rounded-full overflow-hidden">
      {BANDS.map((b) => <div key={b.label} className={`flex-1 ${b.bar} opacity-30`} />)}
    </div>
    {nota !== null && nota !== undefined && (
      <div className="absolute top-1 left-0 h-2.5 rounded-full overflow-hidden" style={{ width: `${nota}%` }}>
        <div className="flex h-full" style={{ width: `${nota ? (100 / nota) * 100 : 0}%` }}>
          {BANDS.map((b) => <div key={b.label} className={`flex-1 ${b.bar}`} />)}
        </div>
      </div>
    )}
    {meta !== undefined && (
      <div className="absolute top-0 -translate-x-1/2 flex flex-col items-center" style={{ left: `${meta}%` }} title={`Meta: ${meta}`}>
        <div className="w-0.5 h-4 bg-slate-800" />
        <span className="text-[10px] text-slate-700 font-medium leading-none mt-0.5">meta {meta}</span>
      </div>
    )}
  </div>
);
